import React, { useEffect, useState } from 'react';
import { BookOpen, ExternalLink, RefreshCw } from 'lucide-react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

// Fallback data artikel terbaru langsung dari enforcea.com/Blog
const FALLBACK_ARTICLES = [
  {
    id: 1,
    title: 'Kewajiban dan Larangan Konsultan Pajak dalam PMK 55 Tahun 2026',
    date: '25/09/2026',
    category: 'Konsultasi Pajak',
    url: 'https://enforcea.com/Blog/kewajiban-dan-larangan-konsultan-pajak-dalam-pmk-55-tahun-2026',
    source: 'enforcea.com',
  },
  {
    id: 2,
    title: 'Izin Konsultan Pajak Tingkat A, B dan C: Apa Bedanya?',
    date: '25/09/2026',
    category: 'Konsultasi Pajak',
    url: 'https://enforcea.com/Blog/izin-konsultan-pajak-tingkat-a-b-dan-c-apa-bedanya',
    source: 'enforcea.com',
  },
  {
    id: 3,
    title: 'Status Pajak WNA Menentukan Kewajiban Pajaknya',
    date: '25/09/2026',
    category: 'Konsultasi Pajak',
    url: 'https://enforcea.com/Blog/status-pajak-wna-menentukan-kewajiban-pajaknya',
    source: 'enforcea.com',
  },
  {
    id: 4,
    title: 'Skema Pemungutan PPN atas Transaksi Digital Luar Negeri',
    date: '24/09/2026',
    category: 'Konsultasi Pajak',
    url: 'https://enforcea.com/Blog/skema-pemungutan-ppn-atas-transaksi-digital-luar-negeri',
    source: 'enforcea.com',
  },
];

export default function EnforceaBlogPanel() {
  const [articles, setArticles] = useState(FALLBACK_ARTICLES);
  const [loading, setLoading] = useState(false);
  const [isLive, setIsLive] = useState(false);

  const fetchArticles = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE}/api/enforcea-articles?limit=5`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: 10000,
      });

      if (res.data?.status === 'ok' && res.data?.data?.length > 0) {
        const mapped = res.data.data.map((item, idx) => {
          let dateStr = item.published_date || '';
          let cat = 'Artikel Pajak';
          if (dateStr.includes('•')) {
            const parts = dateStr.split('•');
            dateStr = parts[0].trim();
            cat = parts[1].trim() || cat;
          }
          return {
            id: item.id || idx + 1,
            title: item.title,
            date: dateStr,
            category: cat,
            url: item.url || 'https://enforcea.com/Blog',
            source: 'enforcea.com',
          };
        });
        setArticles(mapped);
        setIsLive(true);
      }
    } catch (err) {
      console.log('[EnforceaBlogPanel] API not available, using fallback articles');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
    const interval = setInterval(fetchArticles, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="gold-card p-6">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <BookOpen size={14} className="text-[#C41E24]" />
          <span className="text-[10px] uppercase font-bold tracking-[0.2em] text-text-sec">
            ARTIKEL &amp; WAWASAN ENFORCEA
          </span>
          {isLive && (
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" title="Live data" />
          )}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={fetchArticles}
            disabled={loading}
            className="opacity-60 hover:opacity-100 transition-opacity"
            title="Refresh Artikel"
          >
            <RefreshCw size={10} className={`text-text-sec hover:text-[#C41E24] transition-colors ${loading ? 'animate-spin' : ''}`} />
          </button>
          <span className="px-2 py-0.5 rounded-full bg-[#C41E24]/10 text-[#C41E24] text-[10px] font-bold border border-[#C41E24]/20">
            EnforceA
          </span>
        </div>
      </div>

      <div className="space-y-3.5">
        {articles.map((item) => (
          <a
            key={item.id}
            href={item.url || 'https://enforcea.com/Blog'}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-2.5 group border-b border-ledger-border/50 last:border-none pb-3.5 last:pb-0 -mx-3 px-3 py-1.5 rounded-lg hover:bg-surface-inset transition-colors"
          >
            <span className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 bg-[#C41E24]" />
            <div className="min-w-0 flex-1">
              <p className="text-xs text-text-pri group-hover:text-[#C41E24] transition-colors leading-relaxed font-medium">
                {item.title}
              </p>
              <div className="flex items-center gap-2 mt-1.5">
                {item.category && (
                  <span className="text-[9px] uppercase font-semibold px-1.5 py-0.5 rounded bg-[#C41E24]/10 text-[#C41E24] border border-[#C41E24]/15">
                    {item.category}
                  </span>
                )}
                <span className="text-[10px] text-text-sec font-mono">{item.date}</span>
                <span className="text-ledger-border">·</span>
                <span className="text-[10px] text-text-sec">{item.source}</span>
              </div>
            </div>
            <ExternalLink size={12} className="text-text-sec group-hover:text-[#C41E24] mt-1 shrink-0 transition-colors" />
          </a>
        ))}
      </div>

      <div className="pt-3 mt-3 border-t border-ledger-border/40">
        <a
          href="https://enforcea.com/Blog"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-1.5 text-[11px] font-medium text-[#C41E24] hover:text-[#9e161b] transition-colors"
          style={{ textDecoration: 'none' }}
        >
          <span>Kunjungi enforcea.com/Blog</span>
          <ExternalLink size={11} />
        </a>
      </div>
    </div>
  );
}
